import script from "./AdminAnalysisView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAnalysisView.vue?vue&type=script&setup=true&lang=js"

import "./AdminAnalysisView.vue?vue&type=style&index=0&id=60d85b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d85b2e"]])

export default __exports__